module.exports = __webpack_public_path__ + "static/media/no-notifications.1c6bd329.svg";